<script>
  import {opinionModalCurrentArticle, opinionModalToggled} from "../../stores/OpinionModalData";

  import {fetchOpinions} from "../../api/opinions";

  import {marked} from "marked";

  let currentArticle;
  let modalToggled;

  opinionModalCurrentArticle.subscribe(data => currentArticle = data);
  opinionModalToggled.subscribe(data => modalToggled = data);

  function dismissModal() {
    opinionModalToggled.set(false);
  }
</script>

{#if modalToggled}
    {#await fetchOpinions() then opinions}
        <section class="modal-overlay">
            <section class="opinion-modal">
                <img on:click={dismissModal} class="modal-dismiss" src="/images/dismiss.svg" alt="dismiss icon">
                <div class="person-details">
                    <img src={opinions[currentArticle]['image']} alt="fotografia"/>
                    <h3>{opinions[currentArticle]['name']}</h3>
                </div>
                {#each opinions[currentArticle]['opinion'] as paragraph}
                    <p data-aos="fade-up" data-aos-offset="100" class="person-opinion">
                        {@html marked(paragraph)}
                    </p>
                {/each}
            </section>
        </section>
    {/await}
{/if}

<style>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(39, 39, 46, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000;
    }

    .opinion-modal {
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        padding: 1.5rem 2rem;
        max-width: 60vw;
        position: relative;
        max-height: 90vh;
        overflow-y: auto;
    }

    .modal-dismiss {
        position: absolute;
        right: 25px;
        cursor: pointer;
    }

    .person-details {
        display: flex;
        align-items: center;
    }

    .person-details img {
        width: 60px;
        height: 60px;
        border-radius: 100%;
        padding: 2px;
        border: 2px solid #FDCD18;
    }

    .person-details h3 {
        margin: 0;
        margin-left: .75rem;
        font-size: 1.5rem;
    }

    .person-opinion {
        margin-top: 1.25rem;
        line-height: 1.125rem;
        color: #425466;
        font-family: "Work Sans";
    }

    @media (max-width: 768px) {
        .opinion-modal {
            max-width: 90vw;
        }

        .modal-dismiss {
            right: 10px;
            top: 10px;
        }
    }
</style>